const OilRing = ({ letters, isSelected, onClick }) => {
    return (
        <div className={`ring ${isSelected ? 'selected' : ''}`} onClick={onClick}>
            <span>{letters}</span>
        </div>
    );
};

export default OilRing;